import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import MonthOverview from './MonthOverview';
import eventMonthSplitter, { removeEmptyMonth } from '../../services/event-month-splitter';

export const EventMonthListStyles = {
	List: styled.ul`
		list-style: none;
		margin: 0;
		border: 1px solid #e6e6e6;
		border-top: none;
		.no-results {
			border-top: 1px solid #e6e6e6;
			padding: 1rem;
		}
	`,
};

const S = EventMonthListStyles;

const EventMonthList = ({ events }) => {
	const splitted = removeEmptyMonth(eventMonthSplitter(events));

	return (
		<S.List>
			{Object.keys(splitted).sort().map(key => (
				<MonthOverview
					key={key}
					monthNumber={moment.unix(key).month()}
					year={moment.unix(key).year()}
					events={splitted[key]}
				/>
			))
			}
			{Object.keys(splitted).length === 0 && (
				<li className="no-results">Es wurden keine Veranstaltungen gefunden</li>
			)}
		</S.List>
	);
};

export default EventMonthList;
